export interface EntryMap {
  [key: string]: any;
}

const PARAMETERS_REGEX = /:([A-Za-z]{1}[A-Za-z|\d|_]*)/g;

interface Obj {
  [key: string]: any;
}

function isDefined(value: any): boolean {
  return typeof value !== 'undefined';
}

function matchObjectByKeys(keys: string[], obj: Obj): object[] {
  const diffObj = { ...obj };

  const matchObj = keys.reduce((accumulator, key) => {
    const value = diffObj[key];

    if (isDefined(value)) {
      const result = { ...accumulator, [key]: value };

      delete diffObj[key];

      return result;
    }

    return accumulator;
  }, {});

  return [matchObj, diffObj];
}

export function resolvePath(path: string, params: EntryMap): string {
  return Object.keys(params).reduce((current, k) => {
    return current.replace(new RegExp(`:${k}`, 'g'), params[k]);
  }, path);
}

export function getPathParams(path: string): string[] {
  const params = path.match(PARAMETERS_REGEX);

  if (params) {
    return params.map((param) => param.replace(':', ''));
  }

  return [];
}

export function isPathReady(path: string): boolean {
  return !path.match(PARAMETERS_REGEX);
}

export function getResolvedPathAndParameters(path: string, parameters: {}): Obj {
  const pathParamNames = getPathParams(path);
  const [pathParams, queryParams] = matchObjectByKeys(pathParamNames, parameters);
  const resolvedPath = resolvePath(path, pathParams);

  return {
    pathParams,
    queryParams,
    resolvedPath,
  };
}
